import { render } from "./preferences.vue?vue&type=template&id=1921adeb"
import script from "./preferences.js?vue&type=script&lang=js&external"
export * from "./preferences.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__